import React, { createContext, useState, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { createTheme , ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import { getSelectedApiThemeColor } from "../../config";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);
  const [apiThemeColor, setApiThemeColor] = useState(getSelectedApiThemeColor());

  const toggleTheme = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  const theme = useMemo(
    () =>
      createTheme ({
        palette: {
          type: darkMode ? "dark" : "light",
          primary: { main: apiThemeColor },
        },
      }),
    [darkMode, apiThemeColor]
  );

  React.useEffect(() => {
    const handleApiTenantChanged = () => {
      setApiThemeColor(getSelectedApiThemeColor());
    };

    window.addEventListener("apiTenantChanged", handleApiTenantChanged);
    window.addEventListener("storage", handleApiTenantChanged);

    return () => {
      window.removeEventListener("apiTenantChanged", handleApiTenantChanged);
      window.removeEventListener("storage", handleApiTenantChanged);
    };
  }, []);

  const contextValue = useMemo(() => ({ darkMode, toggleTheme }), [darkMode]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};
ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useThemeContext = () => useContext(ThemeContext);
